import type { UserData } from 'src/common/interfaces/user';
import { useGetCountryCodeQuery } from '../slices';

/**
 * Custom hook to get the user's country code with proper fallbacks
 * @param userData - Optional user data from useGetUserQuery()
 * @returns Object containing countryCode (string) and isLoading (boolean)
 */
export const useCountryCode = (userData?: UserData['user']) => {
  const { data: countryCodeData } = useGetCountryCodeQuery(undefined, {
    skip: !!userData?.local?.country,
  });

  const countryCode =
    userData?.local?.country ?? userData?.detectedCountryCode ?? countryCodeData?.data?.countryCode ?? '';

  return {
    countryCode,
  };
};
